import gql from 'graphql-tag';

const AUDIT_LOGS = gql`
  query Query($deviceSerialNo: String!, $limit: Int, $skip: Int) {
    auditLogs(deviceSerialNo: $deviceSerialNo, limit: $limit, skip: $skip) {
      auditData
      type
      customer
      createdOn
      isInternalAudit
    }
  }
`;

export default AUDIT_LOGS;
